const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://172.30.1.101:9000/' : '//api-moss.17m3.com/';
const webUrl = process.env.NODE_ENV == 'development' ? location.origin + '/' : 'https://www.m3guo.com/activity/202512/ad7la4/';
//const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'm.html';
const domain = webUrl + 'index.html';

const activityTime = '12月4日—12月17日';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const wx_share_text = {
 title: '阿斗赶集', // 分享标题
  desc: '12月4日-12月17日，赶集摊位开启双12福利！4大嘉年华礼包、古法沉香、闪光灯优惠购，，解锁嘉年华换装更有好礼相赠！', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202503/adshop/300.jpg', // 分享图标   
}

const issn = '69';

const ajax_url_map = {
  login : host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
  logout : '',
  free : host + 'api/login/kouDai',
  logininfo : host + 'api/user/getLoginInfo',
  userinfo : host + 'api/user/getUserInfo',
  queryplayer : host + 'api/user/getNickName',
  bind : host + 'api/ad/Bind',
  task_info : host + 'api/ad/GetAdData',//获取玩家往期阿斗数据
  task_list : host + 'api/gift/list?type=2',
  ticket_list : host + 'api/order/TicketList',//优惠券信息
  apply_task : host + 'api/Ad/Welfare',//领福利
  goods_list : host + 'api/Ad/List',//店铺列表
  add_basket : host + 'api/Ad/Cut',//砍价
  help : host + 'api/Ad/Help',//助力
  basket_list : host + 'api/Ad/Cart',//购物车/金算盘
  rec_list : host + 'api/Ad/Like',//推荐单独接口
  ex_more_list : host + 'api/Ad/Amaz',//获取换购商品
  buy : host + 'api/Ad/Buy',//购买
  score_info : host + 'api/User/GetScore',//获取积分
  ex_buy_list : host + 'api/gift/list?type=2&orderNum=true',//积分兑换商品列表
  ex_score : host + 'api/Ad/Reward',//积分兑换
  order_list : host + 'api/Ad/OrderList',//账簿
  record_ex : host + 'api/Order/GetOrderList',//兑换记录
  record_score : host + 'api/user/getScoreList?scoreType=0&pageindex=1&pageSize=0',//积分记录
  w12_list : host + 'api/gift/list?type=1&gid=4',
  w12_query : host + 'api/Ad/QuerySkin',//
  w12_invite_list : host + 'api/Ad/GetTeam',//好友列表
  w12_skin_apply : host + 'api/Ad/SkinGift',//领取皮肤奖励
  w12_invite : host + 'api/share/getCode?mode=2',//获取绑定码
  invite_info : host + 'api/share/getNickName',
  w12_invite_apply : host + 'api/Ad/bind12',//绑定
  w12_invite_gift : host + 'api/Ad/bindGift',//绑定消费奖励
  free: host + 'api/login/kouDai', //口袋自登录验证  
  mplat : host + 'api/login/mplat',//梦平台免登录
  tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const formatNum = function (val,max) {
  return Math.min(val,max);
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
},
{
  "id": 21,
  "name": "长生殿(Steam)"
}, 
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
}, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]

const queryArea = function (num){
  var area = '暂无大区信息';

  if (num == 1) {
      area = '火烧赤壁';
  } else if (num == 2) {
      area = '草船借箭';
  } else if (num == 6) {
      area = '荆州之战';
  } else if (num == 7) {
      area = '青梅煮酒';
  } else if (num == 8) {
      area = '官渡之战';
  } else if (num == 9) {
      area = '桃园结义';
  } else if (num == 11) {
      area = '九伐中原';
  } else if (num == 12) {
      area = '逐鹿中原';
  } else if (num == 13) {
      area = '三分天下';
  } else if (num == 16) {
      area = '怀旧服';
  }else if (num == 17) {
      area = '铜雀台';
  } else if (num == 18) {
      area = '凤仪亭';
  }else if (num == 19) {
      area = '火凤燎原';
  }else if (num == 20) {
      area = '卧龙出渊';
  }else if (num == 21) {
      area = '长生殿';
  }else if (num == 100 || num == 101) {
      area = '测试大区';
  }

  return area;
}

const share_format = function(data){
  return data.koudai + '【' + data.shopName + '】'  + data.price + ' ' + data.url;
};

const isIos = function () {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}();

export default {
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    deviceType,
    areaList,
    issn,
    wx_share_text,
    queryArea,
    formatNum,
    activityTime,
    share_format,
    isIos,
}